module.exports = __webpack_public_path__ + "static/media/Mulish-Black.57dcc587.woff2";